import { render } from "./InputHeader.vue?vue&type=template&id=2d4b3686"
import script from "./InputHeader.vue?vue&type=script&lang=js"
export * from "./InputHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__